import { Mail, MapPin, Phone } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { createFileRoute, Link } from "@tanstack/react-router";

import { Footer, Header } from "./index";

export const Route = createFileRoute("/contact")({
	component: RouteComponent
});

function RouteComponent() {
	return (
		<main className="bg-gradient-to-b from-white via-primary/10 to-violet-300">
			<div className="container mx-auto px-2">

				<Header />
				<section className="container mx-auto text-center my-8">
					<h1 className="text-4xl font-bold text-primary mb-4 max-md:text-2xl">Get in touch with us</h1>
					<p className="text-gray-600 max-w-2xl mx-auto max-md:text-sm max-md:max-w-xs ">
						We make sure that our users receive immediate and necessary assistance while using Intasida. Feel free to
						use our call center, or any means of contact to reach out to us.
					</p>
				</section>

				<div className="grid grid-cols-1 md:grid-cols-3 max-w-4xl mx-auto bg-white p-2 rounded-xl">
					<div className="bg-gradient-to-br from-[#3e33b7] to-[#6b60d1] text-white p-8 rounded-xl space-y-8">
						<div className="space-y-4">
							<h2 className="text-2xl font-semibold">Contact Information</h2>
							<p className="text-gray-200 text-xs">
								Contact our call center, or any means of contact to reach out to
								us.
							</p>
						</div>

						<div className="space-y-6">
							<div className="space-y-2">
								<div className="flex items-center gap-3">
									<Phone className="size-5" />
									<span className="text-xs">+234 801 234 5678</span>
								</div>
							</div>

							<div className="flex items-center gap-3">
								<Mail className="size-5" />
								<span className="text-xs">support@intasidatechnologies.com</span>
							</div>

							<div className="flex items-center gap-3">
								<MapPin className="size-5" />
								<span className="text-xs">Enugu, Nigeria</span>
							</div>
						</div>
					</div>
					{/* Contact Form */}
					<div className="p-8 md:col-span-2">
						<form className="space-y-6">
							<div className="grid md:grid-cols-2 gap-4">
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-3">
										Name
										<span className="text-red-500">*</span>
									</label>
									<Input placeholder="Enter your name" required />
								</div>
								<div>
									<label className="block text-sm font-medium text-gray-700 mb-3">
										Email
										<span className="text-red-500">*</span>
									</label>
									<Input type="email" placeholder="Enter your email address" required />
								</div>
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-3">
									Subject
									<span className="text-red-500">*</span>
								</label>
								<Input placeholder="Enter subject" required />
							</div>

							<div>
								<label className="block text-sm font-medium text-gray-700 mb-3">
									Message
									<span className="text-red-500">*</span>
								</label>
								<Textarea placeholder="Enter message" className="min-h-[120px]" required />
							</div>

							<Button className="w-full md:w-auto rounded-3xl bg-primary hover:bg-primary/80">
								Send message
							</Button>
						</form>
					</div>
				</div>

				{/* Newsletter Section */}
				<section className="text-center my-16">
					<h2 className="text-3xl font-bold mb-4 max-md:text-2xl">Keep up with the latest</h2>
					<p className="text-gray-600 mb-8 max-md:text-sm max-md:max-w-xs">Join our newsletter to stay up to date on features and releases.</p>

					<div className="flex flex-col md:flex-row gap-4 justify-center items-center max-w-xl mx-auto">
						<Input type="email" placeholder="Enter your email" className="flex-1" />
						<Button className="w-full md:w-auto bg-primary hover:bg-primary/80">
							Subscribe
						</Button>
					</div>
					<p className="text-sm text-gray-500 mt-4">
						To learn more about how Intasida handles your personal data, check our
						{" "}
						<Link to="/legal" className="text-primary hover:underline">
							Privacy Policy
						</Link>
					</p>
				</section>

				{/* App Download Section */}
				<section className="container mx-auto mb-8 bg-primary text-white rounded-2xl p-8 md:p-16">
					<div className="grid md:grid-cols-2 gap-8 items-center">
						<div>
							<h2 className="text-3xl font-bold mb-4">
								Say Goodbye To Social Media Shopping Scams And Hello To Trusted Transactions.
							</h2>
							<p className="mb-8">Get the app now</p>
							<div className="flex flex-wrap gap-4">
								<a href="#" className="hover:opacity-80">
									<img src="/app_icons/google_store_new.webp" alt="Get it on Google Play" className="h-12" />
								</a>
								<a href="#" className="hover:opacity-80">
									<img src="/app_icons/app_store_new.png" alt="Download on App Store" className="h-12" />
								</a>
							</div>
						</div>
						<div className="hidden md:block">
							<img src="/mock-phones.png" alt="App showcase" className="w-full" />
						</div>
					</div>
				</section>
			</div>
			<Footer />
		</main>
	);
}
